export const ADD_MY_DETAILS = "ADD_MY_DETAILS";
export const EDIT_ADDRESS_SUCCESS = "EDIT_ADDRESS_SUCCESS";
export const EDIT_USER_IMAGE = "EDIT_USER_IMAGE";
